import type { ReactNode } from 'react'

import Link from '@/components/client/seo/link'
import { tw } from '@/lib/utils'

interface SidebarRailHeaderProps {
  title: string
  /** 20px glyph set before the title, in lapis. Decorative — pass an aria-hidden svg. */
  icon: ReactNode
  link: { href: string; label: string }
  className?: string
}

// The heading every article-sidebar rail shares (Featured Products, Related
// Stories): a bold title with a glyph, and a small action link on the right
// that hides when the rail is too narrow to fit both on one line.
export const SidebarRailHeader = ({ title, icon, link, className }: SidebarRailHeaderProps) => (
  <div className={tw('@container/sidebar-rail flex items-center justify-between gap-4', className)}>
    <h3 className="text-navy flex min-w-0 items-center gap-2 text-xl leading-none font-bold tracking-tight whitespace-nowrap">
      <span className="text-lapis flex size-5 shrink-0 [&>svg]:size-full">{icon}</span>
      {title}
    </h3>
    <Link
      href={link.href}
      prefetch={false}
      data-tracking="ignore"
      className="text-lapis hidden shrink-0 text-xs font-bold tracking-wide uppercase hover:underline @min-[22rem]/sidebar-rail:block"
    >
      {link.label}
    </Link>
  </div>
)
